import React from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { Toaster } from '@/components/ui/sonner';

export const AppShell = ({ children }) => (
  <div className="flex min-h-screen bg-background">
    <Sidebar />
    <div className="flex-1 min-w-0 flex flex-col">
      <Topbar />
      <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6">
        <div className="mx-auto w-full max-w-[1280px]">
          {children}
        </div>
      </main>
    </div>
    <Toaster richColors position="top-right" closeButton />
  </div>
);
